// 将数字展示成三位一个逗号的数字
// 例如 10000经过numFormat，会转化成10,000

export const numsFilter = {
  filters: {
    // num 必须是整数，每三位加逗号
    numFormat(num) {
      const numStr = num + ''
      const numArr = numStr.split('').reverse()
      let reserveStr = ''
      numArr.forEach((item, index) => {
        reserveStr += item
        if (
          index + 1 >= 3 &&
          (index + 1) % 3 == 0 &&
          index != numArr.length - 1
        ) {
          reserveStr += ','
        }
      })
      const trueNum = reserveStr.split('').reverse().join('')
      return trueNum
    },
    feetoFixedTwo(money) {
      return (money / 100).toFixed(2)
    }
  }
}

// 首页生成柱状图或者饼状图的方法的封装

import echarts from 'echarts'
export const echartsInit = {
  methods: {
    // 生成柱状图
    initBarEcharts(
      options = {
        xData: {}, // x轴数据
        yData: {}, // y轴数据
        yName: '', // y轴上面展示的单位
        barWidth: '', // 柱状图的宽度
        xTextRotate: false, // x轴文字是否要倾斜
        idName: '', // id名
        grid: {
          left: '3%',
          right: '4%',
          bottom: '0',
          containLabel: true
        }
      }
    ) {
      var chartDom = document.getElementById(options.idName)
      var myChart = echarts.init(chartDom)
      var option

      option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow' // 默认为直线，可选为：'line' | 'shadow'
          }
        },
        grid: options.grid,
        xAxis: [
          {
            type: 'category',
            data: options.xData,
            axisTick: { show: false }
          }
        ],
        yAxis: [
          {
            type: 'value',
            name: options.yName,
            axisLine: { show: false },
            axisTick: { show: false }
            // splitLine: { show: false }
          }
        ],
        series: [
          {
            type: 'bar',
            barWidth: options.barWidth,
            data: options.yData,
            itemStyle: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                {
                  offset: 0,
                  color: '#488ffa'
                },
                {
                  offset: 1,
                  color: 'rgba(97, 73, 241, 0.5)'
                }
              ])
            }
          }
        ]
      }
      if (options.xTextRotate) {
        option.xAxis[0].axisLabel = {
          rotate: -40,
          formatter: function (value) {
            var str = ''
            var num = 5 // 每行显示字数
            var valLength = value.length // 该项x轴字数
            var rowNum = Math.ceil(valLength / num) // 行数

            if (rowNum > 1) {
              for (var i = 0; i < rowNum; i++) {
                var temp = ''
                var start = i * num
                var end = start + num

                temp = value.substring(start, end) + '\n'
                str += temp
              }
              return str
            } else {
              return value
            }
          }
        }
      }

      option && myChart.setOption(option)
    },
    // 生成折线图
    initLineEcharts(
      options = {
        xData: [],
        yData: [],
        yName: '',
        idName: ''
      }
    ) {
      var chartDom = document.getElementById(options.idName)
      var myChart = echarts.init(chartDom)
      var option

      option = {
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          boundaryGap: true,
          data: options.xData,
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          name: options.yName,
          axisLine: { show: false },
          axisTick: { show: false }
        },
        series: [
          {
            data: options.yData,
            type: 'line',
            smooth: true,
            symbol: 'circle',
            symbolSize: 6,
            // lineStyle: {
            //   color: "#488ffa"
            // },
            itemStyle: {
              color: '#488ffa'
            },
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(97, 73, 241, 0.2)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'rgba(97, 73, 241, 0)' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          }
        ]
      }

      option && myChart.setOption(option)
    }
  }
}

// 课程、托管模块的一些数据处理

import OrganizationApi from '@/request/organizationAdmin'
import SchoolAdmin from '@/request/schoolAdmin'
import { formatHour, dateToTimestamp } from '@/utils/utils'
export const dayCareFilter = {
  data() {
    return {
      weekList: ['', '周一', '周二', '周三', '周四', '周五', '周六', '周日']
    }
  },
  filters: {
    // 根据传入的 classTimeType ，返回对应的托管分类
    echoClassTimeTypeStr(classTimeType) {
      let str = ''
      switch (classTimeType) {
        case 2:
        case '2':
          str = '午托'
          break
        case 3:
        case '3':
          str = '晚托'
          break
        default:
          str = '-'
          break
      }
      return str
    },

    // 根据传入的trainingType ， 返回对应的托管类型
    echoTrainingTypeStr(trainingType) {
      let str = ''
      switch (trainingType) {
        case 1:
        case '1':
          str = '基础托管'
          break
        case 2:
        case '2':
          str = '特色托管'
          break
        default:
          str = '-'
          break
      }
      return str
    },
    // 根据教师列表返回拼接好的教师字符串
    echoTeachersStr(teacherVOList) {
      if (teacherVOList.length == 0) {
        return '-'
      }
      let str = ''
      teacherVOList.map((item) => {
        str += `${item.teacherName}、`
      })
      return str.substring(0, str.length - 1)
    },
    // 返回时间
    echoEnrollTimeStr(row) {
      const startStr = new Date(row.enrollTimeBegin).Format('yyyy/MM/dd')
      const endStr = new Date(row.enrollTimeEnd).Format('yyyy/MM/dd')
      return `${startStr}-${endStr}`
    },
    // 回显确认状态
    echoClassroomStateStr(classroomState) {
      let str = ''
      switch (classroomState) {
        case 4:
        case '4':
          str = '已发布'
          break
        default:
          str = '未发布'
          break
      }
      return str
    }
  },
  methods: {
    // 根据上课时间列表，返回拼接好的上课时间字符串
    echoDateTimeVOList(dateTimeVOList) {
      const arr = []
      dateTimeVOList.forEach((item) => {
        const str = `每${this.weekList[item.weekDate]} ${
          item.classTimeBegin
        } - ${item.classTimeEnd}`
        arr.push(str)
      })
      return arr
    },
    // 获取学期列表
    async getTermList(id) {
      const params = {
        schoolId: id || this.userInfo.orgId, // 学校id
        termState: 1 // 启用状态 1启用 2：未启用
      }
      try {
        const res = await OrganizationApi.getlistTerms(params)
        if (res.status == 200) {
          this.termList = res.message
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 获取上课场地列表
    async getSchoolPlaceList(id) {
      const params = {
        schoolId: id || this.userInfo.orgId // 学校id
      }
      try {
        const res = await OrganizationApi.getschoolPlaceListorg(params)
        if (res.status == 200) {
          this.placeList = res.message
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 查询已设置的上课时间
    async getCourseClassPeriod(id) {
      const params = {
        schoolId: id || this.userInfo.orgId // 学校id
      }
      console.log('查询上课时间接口------')
      try {
        const res = await OrganizationApi.getClassTime(params)
        console.log(res, '请求结果')
        if (res.status == 200) {
          this.timeList = []
          res.message.forEach((item) => {
            item.startTime = formatHour(
              dateToTimestamp(item.classTimeBegin) * 1000
            )
            item.endTime = formatHour(dateToTimestamp(item.classTimeEnd) * 1000)
            this.timeList.push(item)
          })
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 查询学校或者服务已经绑定的教师列表
    async getTeacherList(orgId) {
      const params = {
        schoolId: orgId || this.userInfo.orgId // 学校id
      }
      try {
        const res = await OrganizationApi.getDynamicListorg(params)
        if (res.status == 200) {
          this.teacherList = res.message
          console.log('获取老师列表', this.teacherList)
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 获取学校关联的教育服务列表
    async getOrgList() {
      const params = {
        orgId: this.userInfo.orgId // 学校id
      }
      try {
        const res = await SchoolAdmin.getSchoolOrgListMore(params)
        if (res.status === 200) {
          this.orgIdList = res.message
        }
      } catch (err) {
        console.log(err)
      }
    },
    // 获取服务下的学校列表
    async getSchoolList() {
      const params = {
        orgId: this.userInfo.orgId // 学校id
      }
      try {
        const res = await OrganizationApi.getorgSchool(params)
        if (res.status === 200) {
          this.schoolIdList = res.message
        }
      } catch (err) {
        console.log(err)
      }
    }
  }
}
